import {Directive, ElementRef, HostListener, Input, OnDestroy, OnInit} from '@angular/core';

declare let $: any;

@Directive({ selector: '[trapFocusDirective]' })
export class TrapFocusDirective implements OnInit, OnDestroy {
  @Input() returnFocus: Function;
  @Input() timeoutDelay = 50;
  private adaFlag = false;
  private ClearAda = true;
  KEYCODE_TAB = 9;

  constructor(private hostElement: ElementRef) {
  }

  ngOnInit() {
    this.setMobileFocusLoop((this.hostElement.nativeElement as HTMLElement).parentElement);
    setTimeout(() => {
      const modalContent = $(this.hostElement.nativeElement).find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
      const firstFocusableEl = modalContent.first()[0];
      firstFocusableEl.focus();
    }, this.timeoutDelay);
  }

  ngOnDestroy() {
    this.removeMobileFocusLoop();
    this.returnFocus();
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(e: KeyboardEvent): any {
    if (e.key === 'Tab' || e.code === 'Tab') {
      const focusableEls = this.hostElement.nativeElement;
      const modalContent = $(focusableEls).find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
      const firstFocusableEl = modalContent.first()[0];
      const lastFocusableEl = modalContent.last()[0];
      if (e.shiftKey) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    }
  }

  // Adding ada-focus functions to directive since they are not called in the modals
  @HostListener('keyup', ['$event'])
  keyUp(event: KeyboardEvent) {
    if (!this.adaFlag && event.code === 'Tab') {
      $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').addClass('ada-focus');
      this.adaFlag = true;
    }
  }

  @HostListener('window:click', ['$event'])
  onClick(event: MouseEvent) {
    if (this.adaFlag || this.ClearAda) {
      $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').removeClass('ada-focus');
      this.adaFlag = this.ClearAda = false;
    } else if ($(event.target).hasClass('ada-focus')) {
      $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').removeClass('ada-focus');
      this.adaFlag = false;
    }
  }
    setMobileFocusLoop(el: HTMLElement) {
        const { body } = document;
        let currentEl = el;
        do {
          // for every sibling of currentElement, we mark with
          // aria-hidden="true".
          const siblings = currentEl.parentElement.children;
          for (let i = 0; i < siblings.length; i++) {
            const sibling = siblings[i];
            if (sibling !== currentEl && sibling.setAttribute && sibling.nodeName !== 'SCRIPT' && sibling.nodeName !== 'STYLE') {
              sibling.setAttribute('data-old-aria-hidden', sibling.getAttribute('aria-hidden') || 'null');
              sibling.setAttribute('aria-hidden', 'true');
            }
          }
          // we then set the currentEl to be the parent node
          // and repeat (unless the currentNode is the body tag).
          currentEl = currentEl.parentElement;
        } while (currentEl !== body);
      }

    removeMobileFocusLoop() {
        const elsToReset = document.querySelectorAll('[data-old-aria-hidden]');
        for (let i = 0; i < elsToReset.length; i++) {
            const el = elsToReset[i];
            const ariaHiddenVal = el.getAttribute('data-old-aria-hidden');
            if (ariaHiddenVal === 'null') {
                el.removeAttribute('aria-hidden');
            } else {
                el.setAttribute('aria-hidden', ariaHiddenVal);
            } 
            el.removeAttribute('data-old-aria-hidden');
        }
    }
}
